<template>
  <div class="contact">
    <!-- Page Header -->
    <div class="contact-header">
      <div class="contact-header-bg"></div>
      <div class="contact-header-content">
        <h1>Contact Us</h1>
        <p>We're here to help!</p>
      </div>
    </div>

    <!-- Contact Content -->
    <div class="contact-body">
      <div class="contact-intro">
        At CARRIERTAKER STYLE, customer support is our top priority. Whether you need
        assistance with your order, have questions about our ethnic wear collections, or need help with returns,
        our team is always ready to support you.
      </div>

      <!-- Contact Cards Grid -->
      <div class="contact-grid">
        <div class="contact-card">
          <div class="card-icon">📞</div>
          <h3>Customer Support</h3>
          <p>Mobile: +91 XXXXXXXXXX</p>
          <p>Available Monday to Saturday</p>
          <p>Timing: 10:00 AM – 7:00 PM</p>
        </div>
        <div class="contact-card">
          <div class="card-icon">✉️</div>
          <h3>Email Support</h3>
          <p>For all general queries, order issues, feedback, or business enquiries:</p>
          <p>Email: info@carriertakerstyle.in</p>
          <p class="note">We aim to respond within 24–48 hours</p>
        </div>
        <div class="contact-card">
          <div class="card-icon">📍</div>
          <h3>Corporate Office</h3>
          <p>CARRIERTAKER LOGISTICS INDIA PRIVATE LIMITED</p>
          <p>305, Third Floor, Adjoining Bank of India, Industrial Area-A, Cheema Chowk, Ludhiana – 141003 (Punjab), India</p>

          <p class="note">(Visits by appointment only)</p>
        </div>
        <div class="contact-card">
          <div class="card-icon">📦</div>
          <h3>Order &amp; Return Help</h3>
          <p>You can manage your orders anytime through:</p>
          <p>My Account → Orders</p>
          <p class="note">Track order | Request return | Cancel order</p>
        </div>
        <div class="contact-card">
          <div class="card-icon">💬</div>
          <h3>When To Contact Us</h3>
          <p>Delivery issues | Damaged product | Size queries | Delayed refunds | Payment issues</p>
          <router-link class="contact-action" to="/contact-support">Contact Support</router-link>
        </div>
        <div class="contact-card">
          <div class="card-icon">⚖️</div>
          <h3>Grievance Redressal</h3>
          <p>CARRIERTAKER LOGISTICS INDIA PRIVATE LIMITED</p>
          <p>Email: info@carriertakerstyle.in</p>
          <p>Mobile: +91 XXXXXXXXXX</p>
          <p class="note">Mon-Fri, 10AM - 6PM</p>
        </div>
      </div>

      <!-- Feedback Section -->
      <div class="contact-feedback">
        <div class="feedback-content">
          <h3>We Value Your Feedback ❤️</h3>
          <p>Your satisfaction helps us grow. If you have suggestions or ideas that can improve your shopping experience, we'd love to hear from you.</p>
          <p class="highlight">Thank you for choosing CARRIERTAKER STYLE</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactUs'
}
</script>

<style scoped>
.contact {
  background: #F0FDF4;
  min-height: 100vh;
}

/* Page Header */
.contact-header {
  position: relative;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.contact-header-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #1C2A46 0%, #0A1837 50%, #E4ECF5 100%);
}
.contact-header-bg::after {
  content: '';
  position: absolute;
  inset: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
.contact-header-content {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 0 20px;
}
.contact-header-content h1 {
  font-size: 42px;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.contact-header-content p {
  font-size: 18px;
  color: rgba(255,255,255,0.9);
}

/* Contact Body */
.contact-body {
  max-width: 1200px;
  margin: 0 auto;
  padding: 50px 24px 80px;
}
.contact-intro {
  font-size: 15px;
  line-height: 1.8;
  color: #666666;
  margin-bottom: 40px;
  text-align: center;
}

/* Contact Grid */
.contact-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 40px;
}
.contact-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 28px;
  box-shadow: 0 18px 40px rgba(28, 42, 70, 0.08);
  transition: all 0.3s;
  text-align: center;
}
.contact-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 24px 50px rgba(28, 42, 70, 0.12);
}
.card-icon {
  font-size: 40px;
  margin-bottom: 16px;
}
.contact-card h3 {
  font-size: 16px;
  font-weight: 700;
  color: #2D2D2D;
  margin-bottom: 12px;
}
.contact-card p {
  font-size: 13px;
  color: #666666;
  line-height: 1.6;
  margin-bottom: 8px;
}
.contact-card .note {
  font-size: 12px;
  color: #1C2A46;
  font-style: italic;
}
.contact-action {
  display: inline-block;
  margin-top: 16px;
  background: #1C2A46;
  color: #ffffff;
  padding: 10px 20px;
  border-radius: 25px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s;
}
.contact-action:hover {
  background: #0A1837;
  transform: translateY(-2px);
}

/* Feedback Section */
.contact-feedback {
  background: linear-gradient(135deg, #1C2A46 0%, #0A1837 100%);
  border-radius: 20px;
  padding: 40px;
  text-align: center;
  color: #ffffff;
}
.feedback-content h3 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 16px;
}
.feedback-content p {
  font-size: 14px;
  line-height: 1.7;
  opacity: 0.9;
  margin-bottom: 10px;
}
.feedback-content .highlight {
  font-size: 16px;
  font-weight: 600;
  opacity: 1;
  margin-top: 20px;
}

/* Responsive */
@media (max-width: 1024px) {
  .contact-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 900px) {
  .contact-header {
    height: 200px;
  }
  .contact-header-content h1 {
    font-size: 28px;
  }
  .contact-header-content p {
    font-size: 14px;
  }
  .contact-body {
    padding: 30px 12px 60px;
  }
  .contact-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .contact-card {
    padding: 20px;
  }
  .contact-feedback {
    padding: 30px 20px;
  }
}
</style>
